import { SwitchProps, FormControlLabel, Switch, Box } from "@mui/material"
import { Controller, FieldValues, UseControllerProps } from "react-hook-form"

interface ControlledSelectProps<FieldValueProps extends FieldValues>
  extends UseControllerProps<FieldValueProps> {
  label: string
  SwitchProps?: SwitchProps
}

const ControlledSwitch = <FieldValueProps extends FieldValues>({
  control,
  name,
  label,
}: ControlledSelectProps<FieldValueProps>) => (
  <Controller
    control={control}
    name={name}
    render={({
      //   fieldState: { error },
      field: { onChange, onBlur, value },
    }) => (
      <FormControlLabel
        // inputRef={ref}
        onBlur={onBlur}
        onChange={onChange}
        checked={!!value}
        control={
          <Box display="flex" flexDirection="row" justifyContent="left">
            <Box mr={1} alignContent="center">
              No
            </Box>
            <Switch checked={!!value} />
            <Box ml={1} alignContent="center">
              Yes
            </Box>
          </Box>
        }
        disableTypography
        label={label}
        labelPlacement="top"
      />
    )}
  />
)
export default ControlledSwitch
